"use client";

import React from "react";
import { useRouter } from "next/navigation";

import { Path } from "@/internals/constants/paths";
import { getSiteDomain } from "@/utils/site";
import { getDomainConfig } from "@/sites/config/domainConfigs";

export const usePrefetchRouter = (routesToPrefetch: Path[]) => {
  const router = useRouter();
  const hostname = getSiteDomain();

  React.useEffect(() => {
    const initialPrefetchRoutes = getDomainConfig(hostname)?.initialPrefetchRoutes || [];

    const allRoutes = [...new Set([...initialPrefetchRoutes, ...routesToPrefetch])];

    allRoutes.forEach((route) => {
      router.prefetch(route);
    });
  }, []);
};
